import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { Gallery } from "react-grid-gallery";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Col from "react-bootstrap/Col";



export default function ImageGallery({ section }) {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!section || !section.fields || !Array.isArray(section.fields.imageGallery)) {
    return null;
  }

  const images = section.fields.imageGallery
    .map(image => {
      const file = image.fields.file;
      const width = typeof file?.width === 'number' ? file.width : 300; // fallback to 300
      const height = typeof file?.height === 'number' ? file.height : 200; // fallback to 200
      if (!file?.url) return null;
      return {
        src: file.url,
        width,
        height,
        alt: image.fields.title || "",
        caption: image.fields.title || ""
      };
    })
    .filter(Boolean);

  // Handler for clicking an image in the gallery
  const handleImageClick = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  // Prepare slides for yet-another-react-lightbox
  const slides = images.map(img => ({
    src: img.src,
    alt: img.alt,
    description: img.caption,
  }));

  return (
    <Row style={{ paddingBottom: 20 }}>
      <Col>
        <Container id="image-gallery" fluid>
          <h3>{section.fields.headline}</h3>
          <div className="tagline">{section.fields.tagline}</div>
          <p>{section.fields.description}</p>
          <Gallery
            enableImageSelection={false}
            images={images}
            onClick={(index, image, event) => handleImageClick(index)}
          />
          <Lightbox
            open={lightboxOpen}
            close={() => setLightboxOpen(false)}
            slides={slides}
            index={currentIndex}
            plugins={[Thumbnails]}
            thumbnails={{
              position: "bottom",
            }}
            on={{
              view: ({ index }) => setCurrentIndex(index),
            }}
          />
        </Container>
      </Col>
    </Row>
  )
}
